import { Component, EventEmitter, HostListener, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { common } from '../../helpers/helper.common';
import { CityMaster, CountryMaster, District } from '../../models/country.model';
import { Address } from '../../models/merchant';
import { CoreService } from '../../services/core.service';
import { UserService } from '../../services/user.service';
import { element } from 'protractor';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgStyle, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-Pin-Address',
    templateUrl: './PinAddressMap.component.html',
    styleUrls: ['./PinAddressMap.component.scss'],
    standalone: true,
    imports: [NgStyle, GoogleMapsModule, FormsModule, NgSelectModule, AsyncPipe]
})
// Import necessary dependencies
export class PinAddressMapComponent implements OnInit {
  // ViewChild decorator to get a reference to the Addresspopup element in the template

  @ViewChild('Addresspopup', { static: false }) private Addresspopup;
  // Output event emitters for cancel and message events
  @Output() cancel = new EventEmitter();
  @Output() Message = new EventEmitter<string>();
  // Properties
  map: google.maps.Map;
  IsMap = true;
  Merchant$ = this.coreService.Merchant$;
  Country: CountryMaster[];
  District: District[];
  City: CityMaster[];
  selectedCountry: any;
  selectedDistrict: any;
  selectedCity: any;
  markerOptions: google.maps.MarkerOptions = { draggable: true };
  markerPosition: google.maps.LatLngLiteral;
  AddressModal;
  Address: Address;
  // Constructor to inject services and initialize properties
  constructor(private commonService: common, private renderer: Renderer2, private coreService: CoreService, private userService: UserService, private modalService: NgbModal) { }
  // Lifecycle hook: Initialize component properties and fetch country data
  ngOnInit(): void {
    // Load Google Maps script dynamically
    // OLD API KEY
    //  const element =
    //    "https://maps.googleapis.com/maps/api/js?key=AIzaSyCGXsBaDFpyTye8dYsZ8yzu0uCvULjof4E&libraries=visualization";

    // new google map API key update
    const element =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDmfDFJDzO2rRB_8AwbsN06xhth1nubqas&libraries=visualization";
    const scripts = Array.prototype.slice.call(
      document.getElementsByTagName("script")
    );
    if (
      scripts.filter((script) => {
        return script.src.includes(element);
      }).length < 1
    ) {
      const script = this.renderer.createElement("script");
      script.src = element;
      this.renderer.appendChild(document.head, script);
    }
    // Initialize Address and fetch country data
    this.Address = new Address();
    this.coreService.getCountry().subscribe((resp) => {
      if (resp.data) {
        this.Country = resp.data;
        this.City = [];
        this.District = [];
        this.Country.forEach((Country) => {
          if (Country.cities) {
            this.City.push(...Country.cities);
            this.City.forEach((City) => {
              if (City.district) this.District.push(...City.district);
            });
          }
        });
      }
    });
  }
  // Get current location and update marker position

  Getcurrentlocation() {
    this.commonService.getLocation("25.2048", "25.2048").then((response) => {
      var [Distance, userlatitude, userlongitude] = response;
      this.markerPosition = new google.maps.LatLng(userlatitude, userlongitude).toJSON();
      var marker = new google.maps.Marker({
        label: "Point",
        position: { lat: userlatitude, lng: userlongitude },
      });
      this.center = { lat: userlatitude, lng: userlongitude };
      this.zoom = this.zoom == 18 ? 19 : 18;
      this.Getaddress()
    });
  }
  center: google.maps.LatLngLiteral = { lat: 24, lng: 12 };
  zoom = 4;

  // Method to add a marker when the map is clicked
  addMarker(event: google.maps.MapMouseEvent) {

    if (event.latLng != null)
      this.markerPosition = event.latLng.toJSON();
    this.center = this.markerPosition;
    this.Getaddress();
  }
  // Method to update marker position when the marker is dragged
  dragMarker(event: google.maps.MapMouseEvent) {
    if (event.latLng != null)
      this.markerPosition = event.latLng.toJSON();
    this.center = this.markerPosition;
    this.zoom = this.zoom == 18 ? 19 : 18;
    this.Getaddress();
  }
  // Method to get address information from the marker position
  Getaddress() {
    if (this.markerPosition) {
      var geocoder = geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'latLng': this.markerPosition }, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {

          if (results[1]) {
            results[1].address_components.reverse().forEach((element) => {

              switch (element.types[0]) {

                case 'country':
                  {
                    var selectedCountry = this.Country.find(x => x.name.toLowerCase() == element.long_name.toLowerCase());
                    if (selectedCountry) {
                      this.selectedCountry = selectedCountry.id;
                      this.City = selectedCountry.cities;
                    }
                    break;
                  }
                case 'administrative_area_level_2':
                case 'administrative_area_level_1':
                  {
                    if (this.City)
                      var selectedCity = this.City.find(x => x.name.toLowerCase() == element.long_name.toLowerCase())
                    if (selectedCity) {
                      this.District = selectedCity.district;
                      this.selectedCity = selectedCity.id;
                    }
                    break;
                  }
                case 'locality':
                case 'route':
                  {
                    if (this.District)
                      this.selectedDistrict = this.District.find(x => x.name.toLowerCase() == element.long_name.toLowerCase())?.id
                    break;
                  }

                case 'postal_code':
                  {
                    this.Address.postcode = element.long_name
                    break;
                  }
                default:
                  break;
              }

            });
            var addressline = this.split(results[1].formatted_address);
            // old code
            //  this.Address.line_1 = addressline[0];
            //  this.Address.line_2 = addressline[1];
            this.Address.coordinate = (this.markerPosition.lat + ',' + this.markerPosition.lng);

          }
        }
      });

    }
  }
  // Method to get address information from the marker position
  split(string) {
    var newString = [];
    for (var i = 40; i >= 0; i--) {
      if (string.charAt(i) == " ") {
        newString[0] = string.slice(0, i);
        newString[1] = string.slice(i);
        return newString;
      }
    }
  }
  // Method to add a new address
  AddAddress(Form) {
    if (!Form.valid) {
      return;
    }
    var data =
    {
      name: this.Address.name,
      line_1: this.Address.line_1,
      line_2: this.Address.line_2,
      county: 'none',
      type: '0',
      country_id: this.selectedCountry,
      city_id: this.selectedCity,
      district_id: this.selectedDistrict,
      postcode: this.Address.postcode,
      plus_code: this.Address.coordinate,
    }
    if (this.Address.id && this.Address.id > 0)
      this.userService.UpdateAddress(this.Address.id, data).subscribe((response) => {
        this.modalService.dismissAll();
        this.cancel.emit();
        this.Message.emit("New address has been Updated, you will now be redirected to your pending order where you can select the updated address");
      });
    else
      this.userService.AddAddress(data).subscribe((response) => {
        this.modalService.dismissAll();
        this.cancel.emit();
        this.Message.emit("New address has been added, you will now be redirected to your pending order where you can select the new address");
      });

  }
  EditAddress(Address: Address) {
    this.Address = Address;
    var [userlatitude, userlongitude] = this.Address.plus_code.split(",");
    this.markerPosition = new google.maps.LatLng(Number(userlatitude), Number(userlongitude)).toJSON();
    this.center = { lat: Number(userlatitude), lng: Number(userlongitude) };
    this.zoom = this.zoom == 18 ? 19 : 18;
    this.Getaddress();
    this.IsMap = true;
    this.modalService.open(this.Addresspopup, { centered: false, windowClass: 'model', scrollable: true });
  }
  // Method to open the address popup
  Openpopup() {
    this.Address = new Address();
    //Get current location and update marker position
    this.Getcurrentlocation();
    this.IsMap = true;
    this.modalService.open(this.Addresspopup, { centered: false, windowClass: 'model', scrollable: true });
  }
  // Method to handle country change event
  countrychange(event) {
    this.selectedCity = -1;
    this.selectedDistrict = -1;
    this.City = event.cities;
    this.District = [];

  }
  // Method to handle city change event
  citychange(event) {
    this.selectedDistrict = -1;
    this.District = event.district;
  }
  // Method to handle window popstate event
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.modalService.dismissAll();
  }
  // Method to handle zoom map event
  ZoomMap(event: google.maps.MapMouseEvent) {

  }
}
